module.exports = __webpack_public_path__ + "assets/img/tencent_isux.5d49a2e8.png";